
import React, { useState } from 'react';
import { AgentList } from './config/AgentList';
import { AgentConfigurationPanel } from './config/AgentConfigurationPanel';
import { NoAgentSelected } from './config/NoAgentSelected';
import { useAgentConfigurations } from '@/hooks/useAgentConfigurations';
import { RefreshCw } from 'lucide-react';

const AgentConfigPanel = () => {
  const { data: configurations = [], isLoading, error } = useAgentConfigurations();
  const [selectedAgentId, setSelectedAgentId] = useState<string>('');
  const [activeTab, setActiveTab] = useState<string>('general');

  // Select first agent by default when configurations load
  React.useEffect(() => {
    if (configurations.length > 0 && !selectedAgentId) {
      setSelectedAgentId(configurations[0].id);
    }
  }, [configurations, selectedAgentId]);

  const handleAgentChange = (agentId: string) => {
    setSelectedAgentId(agentId);
    setActiveTab('general');
  };

  const handleCreateAgent = () => {
    console.log('Create agent functionality to be implemented');
  };

  const handleConfigUpdate = (updates: any) => {
    console.log('Configuration update:', updates);
  };

  const selectedAgent = configurations.find(config => config.id === selectedAgentId);

  // Show loading state
  if (isLoading) {
    return (
      <div className="flex items-center justify-center p-8">
        <div className="text-center space-y-4">
          <RefreshCw className="h-5 w-5 animate-spin mx-auto" />
          <span>Loading agent configurations...</span>
        </div>
      </div>
    );
  }

  // Show error state
  if (error) {
    return (
      <div className="p-8">
        <div className="text-center text-red-500">
          Error loading agent configurations. Please refresh the page.
        </div>
      </div>
    );
  }

  // Default view with configurations
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
      <AgentList
        configurations={configurations}
        selectedAgentId={selectedAgentId}
        onAgentChange={handleAgentChange}
        onCreateAgent={handleCreateAgent}
      />
      
      {selectedAgent ? (
        <AgentConfigurationPanel
          selectedAgent={selectedAgent}
          activeTab={activeTab}
          onTabChange={setActiveTab}
          onConfigUpdate={handleConfigUpdate}
        />
      ) : (
        <NoAgentSelected onCreateAgent={handleCreateAgent} />
      )}
    </div>
  );
};

export default AgentConfigPanel;
